import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {RequestBody} from '../../entity/core/request-body';
import {LineListRequest} from '../../entity/model/line-list-request';

export default class LineListRequestAgent {

    createLineListRequest = async (organizationId: string, requestBody: RequestBody): Promise<LineListRequest> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/line-list-requests`, requestBody);
    }

    getLineListRequests = async (organizationId: string, titleId: string): Promise<LineListRequest[]> => {
        return await API.get(awsApiName, `/organizations/${organizationId}/line-list-requests?projectTitleID=${titleId}`, {});
    }

    updateLineListRequest = async (organizationId: string, lineListRequestId: string, requestBody: RequestBody): Promise<LineListRequest> => {
        return await API.put(awsApiName, `/organizations/${organizationId}/line-list-requests/${lineListRequestId}`, requestBody);
    }
}
